module.exports = __webpack_public_path__ + "static/media/bg.0b3dd9e4.jpg";